import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import NOB from '../../../../constants/language-strings';
import WorkOrderCompletionFormContainer from '../../../WorkOrderCompletionForm/containers/WorkOrderCompletionFormContainer';
import SlideInPage from '../../../../components/SlideInPage/SlideInPage';
import { TECHNICIAN } from '../../../Authentication/constants';
import { TRAVELING_STATUS } from '../../../../constants/status-codes';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import { useWorkOrder } from 'modules/Workorder/api';
import { useChangeWorkOrderStatus } from 'modules/Workorder/api/use-change-workorder-status';
const NotHomeContainer = styled.div `
  margin: 0 10px;
`;
export const NotHome = () => {
    var _a;
    const location = useLocation();
    const workOrderId = Number((_a = location.pathname.match(/workOrder\/(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]);
    const role = useSelector((state) => state.authentication.role);
    const isTechnician = role === TECHNICIAN;
    const { workOrder } = useWorkOrder(workOrderId);
    const { changeWorkOrderStatus } = useChangeWorkOrderStatus();
    const prevStatus = useRef(null);
    useEffect(() => {
        const status = workOrder === null || workOrder === void 0 ? void 0 : workOrder.status;
        if (isTechnician &&
            status === TRAVELING_STATUS &&
            prevStatus.current !== status) {
            changeWorkOrderStatus({
                workOrderId,
                currentStatus: status,
            });
        }
        prevStatus.current = status;
    }, [isTechnician, workOrderId, workOrder === null || workOrder === void 0 ? void 0 : workOrder.status, changeWorkOrderStatus]);
    return (_jsx(SlideInPage, { mainHeading: NOB.CUSTOMER_NOT_HOME.CUSTOMER_NOT_HOME, showLeftIcon: true, children: _jsx(NotHomeContainer, { children: _jsx(WorkOrderCompletionFormContainer, { customerNotHome: true, workOrder: workOrder }) }) }));
};
